export default __webpack_public_path__ + "static/media/twinstarProtectCrossfire.fca06cb1.jpg";